import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { UserModel } from '@/models/UserModel';
import ProfilePage from '@/pages/ProfilePage';
import ProfilePageGeneralInfo from '@/pages/ProfilePage/ProfilePageGeneralInfo';

import { RoutePath } from '../RoutePath';

import { getCrmAudienceRoutes } from './getCrmAudienceRoutes';
import { getCRMBedboardRoutes } from './getCrmBedboardRoutes';
import { getCrmCampaignRoutes } from './getCrmCampaignRoutes';
import { getCrmOutboundCenterRoutes } from './getCrmOutboundCenterRoutes';
import { getCrmProspectRoutes } from './getCrmProspectRoutes';
import { getCrmReferralSourcesRoutes } from './getCrmReferralSourcesRoutes';
import { getCrmScreenerResidentsRoutes } from './getCrmScreenerResidentsRoutes';
import { getCrmScreenerRoutes } from './getCrmScreenerRoutes';
import { getCrmSourcesRoutes } from './getCrmSourcesRoutes';
import { getCrmWaitlistRoutes } from './getCrmWaitlistRoutes';

export const getCrmRoutes = (currentUser: UserModel): RouteObject[] => {
  const catchAllRoute = currentUser.isScreenerCustomer()
    ? RoutePath.CRMScreenerAllLeads
    : RoutePath.CRMProspectsResidents;

  return [
    {
      path: RoutePath.Profile,
      element: <ProfilePage />,
      children: [
        {
          index: true,
          element: <ProfilePageGeneralInfo />
        }
      ]
    },
    ...getCrmProspectRoutes(),
    ...getCrmReferralSourcesRoutes(),
    ...getCrmOutboundCenterRoutes(),
    ...getCrmAudienceRoutes(),
    ...getCrmCampaignRoutes(),
    ...getCrmScreenerRoutes(),
    ...getCrmScreenerResidentsRoutes(),
    ...getCrmSourcesRoutes(),
    ...getCrmWaitlistRoutes(),
    ...getCRMBedboardRoutes(),
    // Catch-all route
    {
      path: '/*',
      element: <Navigate to={catchAllRoute} replace />
    }
  ];
};
